/**
 * Type-guard primitives for narrowing `unknown`/`Record<string, unknown>` values
 * — used when parsing server-validated chat artifact objects into typed DTOs.
 */

export const asOptionalString = (value: unknown): string | undefined => (typeof value === 'string' ? value : undefined);

export const asOptionalNumber = (value: unknown): number | undefined => (typeof value === 'number' ? value : undefined);

export const asOptionalRecord = (value: unknown): Record<string, unknown> | undefined => {
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    return Object.fromEntries(Object.entries(value));
  }

  return undefined;
};

export const asStringArray = (value: unknown): string[] | undefined =>
  Array.isArray(value) && value.every((entry): entry is string => typeof entry === 'string') ? value : undefined;

export const isEnumValue = <T extends Record<string, string>>(enumObject: T, value: unknown): value is T[keyof T] =>
  typeof value === 'string' && Object.values(enumObject).includes(value);
